'use client';

import { ActionBar as ChakraActionBar } from '@chakra-ui/react';
import type { ActionBarContentProps, ActionBarRootProps } from '@chakra-ui/react';

type ActionBarProps<T extends number | string> = {
	alignItems?:     ActionBarContentProps['alignItems']
	display?:        ActionBarContentProps['display']
	justifyContent?: ActionBarContentProps['justifyContent']
	selected:        T[]
} & ActionBarRootProps;

export function ActionBar<T extends number | string>({
	alignItems = 'center', children,
	display = 'flex',
	justifyContent = 'space-evenly',
	open,
	selected,
	...props
}: ActionBarProps<T>) {
	const isOpen = open ?? (selected.length > 0);

	return (
		<ChakraActionBar.Root open={isOpen} {...props}>
			<ChakraActionBar.Positioner
				bottom="0"
				display="flex"
				insetInline="0"
				justifyContent="stretch"
				position="sticky"
				w="full"
			>
				<ChakraActionBar.Content
					alignItems={alignItems}
					bg="blackAlpha.800"
					borderRadius="md"
					display={display}
					flex="1"
					justifyContent={justifyContent}
					maxW="unset"
					px="sm"
					py="xs"
					w="full"
				>
					{children}
				</ChakraActionBar.Content>
			</ChakraActionBar.Positioner>
		</ChakraActionBar.Root>
	);
}
